
const managed = (path) => {
	// default to MANAGED_URL
	let prefix = process.env.MANAGED_URL;

	if (!prefix) {
		// fallback to determining ASSET_URL from meta tag
		const headPrefix = document.head.querySelector('meta[name="managed-url"]');
		prefix = headPrefix ? headPrefix.content : '';
	}

	const file = path.replace(/^\/+/, '');
	return `${prefix}/${file}`;
};

export default managed;
